import React from "react";
import SkeletonElement from "Components/GMS/Category/Shimmer/SkeletonElement";

const TableBodySkeletonElement = () => {
    return (
        <>
        {[...Array(6)].map((product, singleProductindex) => {
            return (
              <tr key={singleProductindex} className="border-1">
                <th
                  className="border-1 align-middle"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
                <th
                  className="border-1 align-middle"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
                <th
                  className="border-1 align-middle"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
                <th
                  className="border-1 align-middle"
                  style={{
                    position: "sticky",
                    left: "0px",
                    // paddingLeft: "20px",
                    backgroundColor: "#FFFFFF",
                    height: "43",
                    fontFamily: "Noto Sans",
                    fontWeight: 400,
                    padding: "13px 31px 11px 20px",
                  }}
                  title={""}
                >
                  <SkeletonElement type="text" />
                </th>
              </tr>
            );
          })}
        </>
    )
}

export default TableBodySkeletonElement